import { ApiEndpoints } from "./endpoints";
import qs from "qs";
import { EmailSenderTypes } from "../../constants/emailSenderTypes";
import { ProcessEnvironments, axiosClientPortal, axiosClientCore } from "@duosoftbg/nacid-frontoffice-components";

const commonFilterFunction = async (url, params) => {
  const response = await axiosClientPortal.get(url, {
    params,
    paramsSerializer: (params) => {
      return qs.stringify(params);
    },
  });

  return response.data;
};

const commonFilterFunctionCore = async (url, params) => {
  const response = await axiosClientCore.get(url, {
    params,
    paramsSerializer: (params) => {
      return qs.stringify(params);
    },
  });

  return response.data;
};

export const getAllCountries = () => async () => {
  const response = await axiosClientCore.get(`${ApiEndpoints.common.countries}`);
  return response.data;
};

export const getAllNationalUniversities = () => async () => {
  const response = await axiosClientCore.get(`${ApiEndpoints.common.nationalUniversities}`);
  return response.data;
};

export const getDocumentReceiveMethodOptions = () => async () => {
  const response = await axiosClientCore.get(`${ApiEndpoints.documentReceiveMethod.base}`);
  return response.data;
};

export const getContentManagementDataById = (id?: string) => async () => {
  const response = await axiosClientCore.get(`${ApiEndpoints.common.contentManagement}/${id}`);
  return response.data;
};

export const getContentManagementDataByType = (type?: string) => async () => {
  const response = await axiosClientCore.get(`${ApiEndpoints.common.contentManagement}?type=${type}`);
  return response.data;
};

export const userRegistration = (registrationDetails, token) => async () => {
  const withCaptcha = { ...registrationDetails, captchaToken: token };
  const response = await axiosClientPortal.post(ApiEndpoints.users.account, withCaptcha);
  return response.data;
};

export const userAccountActivation = (key) => async () => {
  const response = await axiosClientPortal.patch(`${ApiEndpoints.users.accountActivation}?key=${key}`);
  return response.data;
};

export const createSitemapGroup = (group) => async () => {
  const response = await axiosClientPortal.post(ApiEndpoints.common.sitemapGroupUrl, group);
  return response.data;
};

export const updateSitemapGroup = (group) => async () => {
  const response = await axiosClientPortal.put(`${ApiEndpoints.common.sitemapGroupUrl}/${group.id}`, group);
  return response.data;
};

export const createHomePageCategory = (category) => async () => {
  const response = await axiosClientPortal.post(ApiEndpoints.common.homePageCategoryUrl, category);
  return response.data;
};

export const createHomePageCategoryLink = (link) => async () => {
  const response = await axiosClientPortal.post(ApiEndpoints.common.homePageCategoryLinkUrl, link);
  return response.data;
};

export const updateHomePageCategory = (category) => async () => {
  const response = await axiosClientPortal.put(`${ApiEndpoints.common.homePageCategoryUrl}/${category.id}`, category);
  return response.data;
};

export const updateHomePageCategoryLink = (link) => async () => {
  const response = await axiosClientPortal.put(`${ApiEndpoints.common.homePageCategoryLinkUrl}`, link);
  return response.data;
};

export const deleteHomePageCategory = (id?: string) => async () => {
  const response = await axiosClientPortal.delete(`${ApiEndpoints.common.homePageCategoryUrl}/${id}`);
  return response.data;
};

export const deleteHomePageCategoryLink = (id?: string) => async () => {
  const response = await axiosClientPortal.delete(`${ApiEndpoints.common.homePageCategoryLinkUrl}/${id}`);
  return response.data;
};

export const updateContacts = (contacts) => async () => {
  const response = await axiosClientPortal.put(`${ApiEndpoints.common.contactsUrl}`, contacts);
  return response.data;
};

export const deleteSitemapGroup = (id?: string) => async () => {
  const response = await axiosClientPortal.delete(`${ApiEndpoints.common.sitemapGroupUrl}/${id}`);
  return response.data;
};

export const createSitemapSubGroup = (subGroup) => async () => {
  const response = await axiosClientPortal.post(ApiEndpoints.common.sitemapSubGroupUrl, subGroup);
  return response.data;
};

export const updateSitemapSubGroup = (subGroup) => async () => {
  const response = await axiosClientPortal.put(`${ApiEndpoints.common.sitemapSubGroupUrl}/${subGroup.id}`, subGroup);
  return response.data;
};

export const deleteSitemapSubGroup = (id?: string) => async () => {
  const response = await axiosClientPortal.delete(`${ApiEndpoints.common.sitemapSubGroupUrl}/${id}`);
  return response.data;
};

export const createSitemapLink = (link) => async () => {
  const response = await axiosClientPortal.post(ApiEndpoints.common.sitemapLinkUrl, link);
  return response.data;
};

export const updateSitemapLink = (link) => async () => {
  const response = await axiosClientPortal.put(`${ApiEndpoints.common.sitemapLinkUrl}/${link.id}`, link);
  return response.data;
};

export const deleteSitemapLink = (id?: string) => async () => {
  const response = await axiosClientPortal.delete(`${ApiEndpoints.common.sitemapLinkUrl}/${id}`);
  return response.data;
};

export const feedbackSubmission = (feedbackDetails, captchaToken) => async () => {
  const withCaptcha = { ...feedbackDetails, captchaToken: captchaToken };
  const response = await axiosClientPortal.post(ApiEndpoints.feedbacks, withCaptcha);
  return response.data;
};

export const lawSubmission = (lawDetails) => async () => {
  const data = { ...lawDetails };
  const response = await axiosClientPortal.put(ApiEndpoints.common.lawUrl, data);
  return response.data;
};

export const selectFeedbacks = (params) => async () => {
  return commonFilterFunction(ApiEndpoints.feedbacks, params);
};

export const selectGlobalMessages = (params) => async () => {
  return commonFilterFunction(ApiEndpoints.globalMessages, params);
};

export const markFeedbackAsRead = (id) => async () => {
  const response = await axiosClientPortal.patch(`${ApiEndpoints.feedbacks}/${id}?feedbackAction=FEEDBACK_IS_READ`);
  return response.data;
};

export const deleteReadFeedbacks = () => async () => {
  const response = await axiosClientPortal.delete(`${ApiEndpoints.feedbacks}?feedbackAction=FEEDBACK_DELETE_READ`);
  return response.data;
};

export const uploadFile = (file, captchaToken, fileGroup) => async () => {
  const formData = new FormData();
  formData.append("file", file, file.name);
  formData.append("captchaToken", captchaToken);
  formData.append("relativePath", ProcessEnvironments.FilePath.Portal);
  if (fileGroup !== null) {
    formData.append("fileGroup", fileGroup);
  }
  const response = await axiosClientCore.post(ApiEndpoints.files.upload, formData);
  return response.data;
};

export const uploadFileRestricted = (file, fileGroup) => async () => {
  const formData = new FormData();
  formData.append("file", file, file.name);
  formData.append("relativePath", ProcessEnvironments.FilePath.Portal);
  if (fileGroup !== null) {
    formData.append("fileGroup", fileGroup);
  }
  const response = await axiosClientCore.post(ApiEndpoints.filesRestricted.upload, formData);
  return response.data;
};

export const buildFetchFileUrl = (relativePath, fileId, rootDirectory) => {
  if (rootDirectory === null) {
    return `${axiosClientCore.defaults.baseURL}${ApiEndpoints.files.content}?rootDirectory=${ProcessEnvironments.FilePath.Portal}&relativePath=${relativePath}&fileId=${fileId}`;
  }
  return `${axiosClientCore.defaults.baseURL}${ApiEndpoints.files.content}?relativePath=${relativePath}&fileId=${fileId}&rootDirectory=${rootDirectory}`;
};

export const searchEmailNotifications = (params) => async () => {
  return commonFilterFunction(ApiEndpoints.email.notifications, params);
};

export const getEmailNotification = (id?: string) => async () => {
  const response = await axiosClientPortal.get(`${ApiEndpoints.email.notifications}/${id}`);
  return response.data;
};

export const getEmailNotificationStatuses = () => async () => {
  const response = await axiosClientPortal.get(`${ApiEndpoints.email.notificationStatuses}`);
  return response.data;
};

export const getGlobalMessageTypes = () => async () => {
  const response = await axiosClientPortal.get(`${ApiEndpoints.globalMessageTypes}`);
  return response.data;
};

export const getServiceDefinitions = () => async () => {
  const response = await axiosClientPortal.get(`${ApiEndpoints.serviceDefinitions}`);
  return response.data;
};

export const getPublicGlobalMessages = () => async () => {
  const response = await axiosClientPortal.get(`${ApiEndpoints.publicGlobalMessages}`);
  return response.data;
};

export const deleteEmailNotification = (id: number) => async () => {
  const response = await axiosClientPortal.delete(`${ApiEndpoints.email.notifications}/${id}`);
  return response.data;
};

export const resendEmailNotification = (id) => async () => {
  const response = await axiosClientPortal.post(ApiEndpoints.email.notifications, {
    id: id,
  });
  return response.data;
};

export const forgottenPassword = (forgottenPasswordDetails, captchaToken) => async () => {
  const emailSenderWithCaptcha = {
    type: EmailSenderTypes.FORGOTTEN_PASSWORD,
    data: { ...forgottenPasswordDetails, captchaToken: captchaToken },
  };
  const response = await axiosClientPortal.post(ApiEndpoints.email.sender, emailSenderWithCaptcha);
  return response.data;
};

export const forgottenUsername = (forgottenUsernameDetails, captchaToken) => async () => {
  const emailSenderWithCaptcha = {
    type: EmailSenderTypes.FORGOTTEN_USERNAME,
    data: { ...forgottenUsernameDetails, captchaToken: captchaToken },
  };
  const response = await axiosClientPortal.post(ApiEndpoints.email.sender, emailSenderWithCaptcha);
  return response.data;
};

export const activationLink = (activationLinkDetails, captchaToken) => async () => {
  const emailSenderWithCaptcha = {
    type: EmailSenderTypes.ACTIVATION_LINK,
    data: { ...activationLinkDetails, captchaToken: captchaToken },
  };
  const response = await axiosClientPortal.post(ApiEndpoints.email.sender, emailSenderWithCaptcha);
  return response.data;
};

export const changeEmail = (changeEmailDetails) => async () => {
  const emailSenderChangeEmail = {
    type: EmailSenderTypes.UPDATE_EMAIL,
    data: changeEmailDetails.email,
  };
  const response = await axiosClientPortal.post(ApiEndpoints.email.sender, emailSenderChangeEmail);
  return response.data;
};

export const resetPasswordValidation = (key) => async () => {
  const response = await axiosClientPortal.get(`${ApiEndpoints.users.userData.recovery.password}`, {
    params: {
      key: key,
    },
  });
  return response.data;
};

export const resetPassword = (resetPasswordDetails, captchaToken, key) => async () => {
  const withCaptcha = { ...resetPasswordDetails, captchaToken: captchaToken, key: key };
  const response = await axiosClientPortal.put(`${ApiEndpoints.users.userData.recovery.password}`, withCaptcha);
  return response.data;
};

export const searchEmailTemplates = (params) => async () => {
  return commonFilterFunction(ApiEndpoints.email.templates, params);
};

export const getEmailTemplate = (id?: string) => async () => {
  const response = await axiosClientPortal.get(`${ApiEndpoints.email.templates}/${id}`);
  return response.data;
};
export const getGlobalMessage = (id?: string) => async () => {
  const response = await axiosClientPortal.get(`${ApiEndpoints.globalMessages}/${id}`);
  return response.data;
};

export const getEmailBaseTemplate = () => async () => {
  const response = await axiosClientPortal.get(`${ApiEndpoints.email.templates}/BASE`);
  return response.data;
};

export const createEmailTemplate = (template) => async () => {
  const response = await axiosClientPortal.post(ApiEndpoints.email.templates, template);
  return response.data;
};

export const updateEmailTemplate = (template) => async () => {
  const response = await axiosClientPortal.put(ApiEndpoints.email.templates, template);
  return response.data;
};

export const createGlobalMessage = (template) => async () => {
  const response = await axiosClientPortal.post(ApiEndpoints.globalMessages, template);
  return response.data;
};

export const createServiceDefinition = (template) => async () => {
  const response = await axiosClientPortal.post(ApiEndpoints.serviceDefinitions, template);
  return response.data;
};

export const updateGlobalMessage = (template) => async () => {
  const response = await axiosClientPortal.put(ApiEndpoints.globalMessages, template);
  return response.data;
};

export const updateServiceDefinition = (template) => async () => {
  const response = await axiosClientPortal.put(ApiEndpoints.serviceDefinitions, template);
  return response.data;
};

export const deleteEmailTemplate = (id: number) => async () => {
  const response = await axiosClientPortal.delete(`${ApiEndpoints.email.templates}/${id}`);
  return response.data;
};

export const deleteServiceDefinition = (id: string) => async () => {
  const response = await axiosClientPortal.delete(`${ApiEndpoints.serviceDefinitions}/${id}`);
  return response.data;
};

export const deleteGlobalMessage = (id: number) => async () => {
  const response = await axiosClientPortal.delete(`${ApiEndpoints.globalMessages}/${id}`);
  return response.data;
};

export const changeGlobalMessageVisibility = (id: number) => async () => {
  const response = await axiosClientPortal.put(`${ApiEndpoints.globalMessages}/change-visibility/${id}`);
  return response.data;
};

export const searchRoles = (params) => async () => {
  return commonFilterFunction(ApiEndpoints.roles.search, params);
};

export const getFullRoleDetails = (id: string) => async () => {
  const response = await axiosClientPortal.get(`${ApiEndpoints.roles.fullDetails}/${id}`);
  return response.data;
};

export const getUsersAutocomplete = (inputValue, page, resultsLimit) => async () => {
  return commonFilterFunction(ApiEndpoints.users.autocomplete, {
    username: inputValue,
    page: page,
    pageSize: resultsLimit,
  });
};

export const getUsersWithAdditionalParamsAutocomplete =
  (inputValue, page, resultsLimit, additionalParams) => async () => {
    return commonFilterFunction(ApiEndpoints.users.autocomplete, {
      ...additionalParams,
      username: inputValue,
      page: page,
      pageSize: resultsLimit,
    });
  };

export const addUserToRole = (roleId, userId) => async () => {
  const response = await axiosClientPortal.post(`${ApiEndpoints.roles.addUser}?roleId=${roleId}&userId=${userId}`);
  return response.data;
};

export const removeUserFromRole = (roleId, userId) => async () => {
  const response = await axiosClientPortal.post(`${ApiEndpoints.roles.removeUser}?roleId=${roleId}&userId=${userId}`);
  return response.data;
};

export const searchGroups = (params) => async () => {
  return commonFilterFunction(ApiEndpoints.groups.search, params);
};

export const getFullGroupDetails = (id: string) => async () => {
  const response = await axiosClientPortal.get(`${ApiEndpoints.groups.fullDetails}/${id}`);
  return response.data;
};

export const saveGroupMainDetails = (group) => async () => {
  const response = await axiosClientPortal.post(`${ApiEndpoints.groups.save}`, group);
  return response.data;
};

export const deleteGroup = (id: string) => async () => {
  const response = await axiosClientPortal.delete(`${ApiEndpoints.groups.delete}/${id}`);
  return response.data;
};

export const addUserToGroup = (groupId, userId) => async () => {
  const response = await axiosClientPortal.post(`${ApiEndpoints.groups.addUser}?groupId=${groupId}&userId=${userId}`);
  return response.data;
};

export const removeUserFromGroup = (groupId, userId) => async () => {
  const response = await axiosClientPortal.post(
    `${ApiEndpoints.groups.removeUser}?groupId=${groupId}&userId=${userId}`,
  );
  return response.data;
};

export const addRoleToGroup = (groupId, roleId) => async () => {
  const response = await axiosClientPortal.post(`${ApiEndpoints.groups.addRole}?groupId=${groupId}&roleId=${roleId}`);
  return response.data;
};

export const removeRoleFromGroup = (groupId, roleId) => async () => {
  const response = await axiosClientPortal.post(
    `${ApiEndpoints.groups.removeRole}?groupId=${groupId}&roleId=${roleId}`,
  );
  return response.data;
};

export const getRolesAutocomplete = (inputValue, page, resultsLimit) => async () => {
  return commonFilterFunction(ApiEndpoints.roles.autocomplete, {
    name: inputValue,
    page: page,
    pageSize: resultsLimit,
  });
};

export const getSettlementsAutocomplete = (inputValue, page, resultsLimit) => async () => {
  return commonFilterFunctionCore(ApiEndpoints.settlement.autocomplete, {
    name: inputValue,
    page: page,
    pageSize: resultsLimit,
  });
};

export const getSettlement = (id) => async () => {
  const response = await axiosClientCore.get(`${ApiEndpoints.settlement.baseUrl}/${id}`);
  return response.data;
};

export const getRolesWithAdditionalParamsAutocomplete =
  (inputValue, page, resultsLimit, additionalParams) => async () => {
    return commonFilterFunction(ApiEndpoints.roles.autocomplete, {
      ...additionalParams,
      name: inputValue,
      page: page,
      pageSize: resultsLimit,
    });
  };

export const searchUsers = (params) => async () => {
  return commonFilterFunction(ApiEndpoints.users.search, params);
};

export const getFullUserDetails = (id) => async () => {
  const response = await axiosClientPortal.get(`${ApiEndpoints.users.fullDetails}/${id}`);
  return response.data;
};

export const saveUserMainDetails = (user) => async () => {
  const response = await axiosClientPortal.post(`${ApiEndpoints.users.save}`, user);
  return response.data;
};

export const getGroupsAutocomplete = (inputValue, page, resultsLimit, additionalParams) => async () => {
  return commonFilterFunction(ApiEndpoints.groups.autocomplete, {
    ...additionalParams,
    name: inputValue,
    page: page,
    pageSize: resultsLimit,
  });
};

export const getGroupsWithAdditionalAutocomplete = (inputValue, page, resultsLimit, additionalParams) => async () => {
  return commonFilterFunction(ApiEndpoints.groups.autocomplete, {
    ...additionalParams,
    name: inputValue,
    page: page,
    pageSize: resultsLimit,
  });
};

export const getUserInfo = () => async () => {
  const response = await axiosClientPortal.get(ApiEndpoints.users.myAccount);
  return response.data;
};

export const updateUserMainData = (mainUserData) => async () => {
  const response = await axiosClientPortal.patch(ApiEndpoints.users.userData.update.mainData, mainUserData);
  return response.data;
};

export const userChangeEmail = (key) => async () => {
  const response = await axiosClientPortal.patch(`${ApiEndpoints.users.userData.update.email}?key=${key}`);
  return response.data;
};

export const userChangePassword = (passwordDetails) => async () => {
  const response = await axiosClientPortal.patch(ApiEndpoints.users.userData.update.password, passwordDetails);
  return response.data;
};

export const createAcSection = (sectionDetails, selectedRoles) => async () => {
  const acSectionDetails = { ...sectionDetails, accessRoles: selectedRoles.map((role) => role.id) };
  const response = await axiosClientPortal.post(ApiEndpoints.ac.section, acSectionDetails);
  return response.data;
};

export const editAcSection = (sectionDetails, selectedRoles) => async () => {
  const acSectionDetails = { ...sectionDetails, accessRoles: selectedRoles.map((role) => role.id) };
  const response = await axiosClientPortal.put(ApiEndpoints.ac.section, acSectionDetails);
  return response.data;
};

export const deleteAcSection = (id) => async () => {
  const response = await axiosClientPortal.delete(`${ApiEndpoints.ac.section}/${id}`);
  return response.data;
};

export const createAcPage = (pageDetails, selectedRoles) => async () => {
  const acSectionDetails = { ...pageDetails, accessRoles: selectedRoles.map((role) => role.id) };
  const response = await axiosClientPortal.post(ApiEndpoints.ac.page, acSectionDetails);
  return response.data;
};

export const editAcPage = (pageDetails, selectedRoles) => async () => {
  const acSectionDetails = { ...pageDetails, accessRoles: selectedRoles.map((role) => role.id) };
  const response = await axiosClientPortal.put(ApiEndpoints.ac.page, acSectionDetails);
  return response.data;
};

export const deleteAcPage = (id) => async () => {
  const response = await axiosClientPortal.delete(`${ApiEndpoints.ac.page}/${id}`);
  return response.data;
};

// REFERENCE DATA

export const getReferenceDataDomains = () => async () => {
  const response = await axiosClientCore.get(ApiEndpoints.referenceData.domains);
  return response.data;
};

export const getReferenceDataByDomain = (domain: string) => async () => {
  const response = await axiosClientCore.get(`${ApiEndpoints.referenceData.base}?domain=${domain}&onlyActive=true`);
  return response.data;
};

export const searchReferenceData = (params) => async () => {
  return commonFilterFunctionCore(ApiEndpoints.referenceData.search, params);
};

export const searchNationalUniversities = (params) => async () => {
  return commonFilterFunctionCore(ApiEndpoints.nationalUniversities.search, params);
};

export const getReferenceData = (domain: string, id: string) => async () => {
  const response = await axiosClientCore.get(`${ApiEndpoints.referenceData.base}/${domain}/${id}`);
  return response.data;
};

export const getNationalUniversity = (id: string) => async () => {
  const response = await axiosClientCore.get(`${ApiEndpoints.nationalUniversities.base}/${id}`);
  return response.data;
};

export const createReferenceData = (referenceData) => async () => {
  const response = await axiosClientCore.post(ApiEndpoints.referenceData.base, referenceData);
  return response.data;
};

export const createNationalUniversity = (nationalUniversityData) => async () => {
  const response = await axiosClientCore.post(ApiEndpoints.nationalUniversities.base, nationalUniversityData);
  return response.data;
};

export const updateReferenceData = (referenceData) => async () => {
  const response = await axiosClientCore.put(ApiEndpoints.referenceData.base, referenceData);
  return response.data;
};

export const updateNationalUniversity = (nationalUniversityData) => async () => {
  const response = await axiosClientCore.put(ApiEndpoints.nationalUniversities.base, nationalUniversityData);
  return response.data;
};

export const deleteReferenceData = (domain: string, id: string) => async () => {
  const response = await axiosClientCore.delete(`${ApiEndpoints.referenceData.base}/${domain}/${id}`);
  return response.data;
};

export const deleteNationalUniversity = (id: string) => async () => {
  const response = await axiosClientCore.delete(`${ApiEndpoints.nationalUniversities.base}/${id}`);
  return response.data;
};

export const getExtractedBirthDate = (personalId) => async () => {
  const response = await axiosClientCore.get(`${ApiEndpoints.person.extractDateFromCivilId}/${personalId}`);
  return response.data;
};

export const clearNomenclaturesCache = (axiosClient) => async () => {
  const response = await axiosClient.get(`${ApiEndpoints.cache.clearNomenclatures}`);
  return response.data;
};

export const clearKeycloakCache = () => async () => {
  const response = await axiosClientCore.get(ApiEndpoints.cache.clearKeycloak);
  return response.data;
};

// Qual compare
export const searchCountryDetails = (filter?) => async () => {
  const response = await axiosClientPortal.get(ApiEndpoints.qualCompare.countryDetails.search, {
    params: {
      ...filter,
    },
  });
  return response.data;
};

export const getCountryRegions = () => async () => {
  const response = await axiosClientPortal.get(`${ApiEndpoints.qualCompare.nomenclature.countryRegion}`);
  return response.data;
};

export const getSystemTypes = () => async () => {
  const response = await axiosClientPortal.get(`${ApiEndpoints.qualCompare.nomenclature.systemType}`);
  return response.data;
};

export const searchCountryQFData = (countryId: string) => async () => {
  const response = await axiosClientPortal.get(`${ApiEndpoints.qualCompare.countryDetails.qfDetails}/${countryId}`);
  return response.data;
};
